"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateStripePaymentMethod = void 0;
var _reactStripeJs = require("@stripe/react-stripe-js");
var _toast = require("./toast");
var _react = require("react");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var useCreateStripePaymentMethod = function useCreateStripePaymentMethod() {
  var stripe = (0, _reactStripeJs.useStripe)();
  var createPaymentMethod = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(cardElement) {
      var result, error;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return stripe.createPaymentMethod({
                type: 'card',
                card: cardElement
              });
            case 2:
              result = _context.sent;
              error = result.error;
              if (error) {
                _toast.toast.error({
                  title: 'Could not save payment method',
                  description: error.message
                });
              }
              return _context.abrupt("return", result);
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  return {
    createPaymentMethod: createPaymentMethod
  };
};
exports.useCreateStripePaymentMethod = useCreateStripePaymentMethod;